import $api from "../http/index";
import { AxiosResponse } from 'axios';
import { AuthResponse } from "../pages/models/response/AuthResponse";

export async function newpass(newPass: string, studentId: string): Promise<AxiosResponse<AuthResponse>> {
  const data = { newPass: newPass };
  return $api.put(`v1/setNewPuser/${studentId}`, data);
}

export async function deluser ( studentId: string): Promise<AxiosResponse<AuthResponse>>  {

  return $api.delete(`/v1/delUser/${studentId}`);
  }


export async function getdatausr(studentId: string): Promise<AxiosResponse<AuthResponse>> {
  try {
    const response = await $api.get(`v1/getUserData/${studentId}`);
    return response;
  } catch (error) {
    throw error instanceof Error ? error : new Error('Failed to fetch user data');
  }
}

export interface UserDataUpdate {
  name?: string;
  surname?: string;
  pnr?: string;
  phone?: string;
  category?: string[];
  autotransmission?: boolean;
}

export async function svdatausr(studentId: string, data: UserDataUpdate): Promise<AxiosResponse<AuthResponse>> {
  try {
    const response = await $api.put(`v1/updUserData/${studentId}`, data);
    return response;
  } catch (error) {
    throw new Error('Failed');  // Throw an Error object instead of a string
  }
}

export interface UserDataUpdate2 {
  autotransmission?: boolean;
}

export async function svdatausr2(studentId: string, data: UserDataUpdate2): Promise<AxiosResponse<AuthResponse>> {
  try {
    const response = await $api.put(`v1/updUserData2/${studentId}`, data);
    return response;
  } catch (error) {
    throw new Error('Failed');  // Throw an Error object instead of a string
  }
}

export async function updatedeals(userEmail: string): Promise<AxiosResponse<AuthResponse>> { // Parameter name changed to userEmail for clarity
  try {
    const response = await $api.put(`/v1/dealsreminder`, { email: userEmail }); // <-- THIS IS THE CRITICAL CHANGE
    return response;
  } catch (error: any) {
    console.error("❌ StudentService: API error:", error.response?.data || error.message);
    throw error;
  }
}

export async function controllesson(email: string): Promise<AxiosResponse<AuthResponse>> {
  try {
    const response = await $api.put(`/v1/controllesson`, email);
    return response;
  } catch (error) {
    throw new Error('Failed');  // Throw an Error object instead of a string
  }
}
